import * as React from "react";
const SvgFiRrGraduationCap = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-graduation-cap_svg__a)">
      <path
        fill="#062147"
        d="m22.057 5.23-7.374-3.513A5.23 5.23 0 0 0 9.4 1.672L1.943 5.23l-.084.045a3.691 3.691 0 0 0 .084 6.455L4 12.71v4.9a5.01 5.01 0 0 0 3.519 4.778c1.455.421 2.965.627 4.48.612a15.6 15.6 0 0 0 4.482-.607A5.01 5.01 0 0 0 20 17.615v-4.907l2-.956V20a1 1 0 0 0 2 0V8c.006-1.174-.92-2.26-1.944-2.77M18 17.615a3 3 0 0 1-2.1 2.863A13.6 13.6 0 0 1 12 21a13.6 13.6 0 0 1-3.9-.522A3 3 0 0 1 6 17.615v-3.952l3.317 1.58a5.27 5.27 0 0 0 2.705.739 5 5 0 0 0 2.577-.694l3.4-1.625zm3.2-7.69-7.542 3.6a3.3 3.3 0 0 1-3.39-.045l-7.38-3.51a1.692 1.692 0 0 1-.036-2.958l7.495-3.58a3.3 3.3 0 0 1 3.39.045L21.11 6.99c.542.301.881.87.889 1.49a1.7 1.7 0 0 1-.8 1.445"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-graduation-cap_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGraduationCap;
